/* Presentation only. Never mutate URLs, product identifiers or input values. */
(() => {
  const dash = /[\u002d\u00ad\u2010-\u2015\u2212]/g;
  const needsClean = /[\u002d\u00ad\u2010-\u2015\u2212]| {2}/;
  const attributeKeys = ['aria-label','alt','title','placeholder'];
  function normalizeAttributes(el) {
    if (!el.getAttribute) return;
    attributeKeys.forEach(key => {
      const val = el.getAttribute(key);
      if (val && needsClean.test(val)) {
        const value = clean(val);
        if (value !== val) el.setAttribute(key, value);
      }
    });
  }
  const clean = value => value.replace(/\b(\d{4})-(\d{2})-(\d{2})\b/g, '$2/$3/$1').replace(/\b(\d{3})-(\d{3})-(\d{4})\b/g, '$1 $2 $3').replace(/(^|[\s(])[-\u2212](?=\$?\d)/g, '$1minus ').replace(/(\d)[\u002d\u2010-\u2015](?=\d)/g, '$1 to ').replace(dash, ' ').replace(/ {2,}/g, ' ');
  function normalize(root) {
    const visit = node => {
      if (!needsClean.test(node.nodeValue || '')) return;
      if (!node.parentElement || node.parentElement.closest('script,style,noscript,textarea,input,code,pre,[contenteditable]')) return;
      const value = clean(node.nodeValue);
      if (value !== node.nodeValue) {
        const option = node.parentElement.closest('option');
        if (option && !option.hasAttribute('value')) option.setAttribute('value', option.value);
        node.nodeValue = value;
      }
    };
    if (root.nodeType === Node.TEXT_NODE) return visit(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) visit(walker.currentNode);
    if (root.querySelectorAll) {
      normalizeAttributes(root);
      root.querySelectorAll('[aria-label],[alt],[title],[placeholder]').forEach(normalizeAttributes);
    }
  }
  function init() {
    normalize(document.body);
    document.title = clean(document.title);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') normalizeAttributes(record.target);
        else if (record.type === 'characterData') normalize(record.target);
        else record.addedNodes.forEach(normalize);
      }
    }).observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','alt','title','placeholder']});
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') document.querySelectorAll('.n-mobile[open]').forEach(el => { el.open=false; el.querySelector('summary').focus(); });
    });
    document.addEventListener('click', event => {
      if (event.target.closest('[data-n-chat]') && window.LiveChatWidget) {
        event.preventDefault(); window.LiveChatWidget.call('maximize');
      }
      document.querySelectorAll('.n-mobile[open]').forEach(el => {if (!el.contains(event.target)) el.open=false;});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
